"use client";

import { motion } from "motion/react";
import { locationsData } from "@/lib/contact-data";

export default function LocationSection() {
  return (
    <section className="px-6 pb-24">
      <motion.div
        initial={{ opacity: 0, scale: 0.98 }}
        whileInView={{ opacity: 1, scale: 1 }}
        viewport={{ once: true }}
        transition={{ duration: 0.8, ease: "circOut" }}
        // Uses your specific gradient tokens
        className="max-w-[83.75rem] mx-auto bg-gradient-to-br from-primary to-danger rounded-[3rem] p-12 md:p-20 relative overflow-hidden shadow-2xl shadow-primary/30"
      >
        {/* Background Decor */}
        <div className="absolute top-0 right-0 w-[800px] h-[800px] bg-white/10 rounded-full blur-3xl translate-x-1/2 -translate-y-1/2 pointer-events-none"></div>

        {/* Grid Layout matches the width constraints */}
        <div className="relative z-10 grid lg:grid-cols-2 gap-16 lg:gap-24">
          {locationsData.map((loc, idx) => (
            <div
              key={idx}
              className={`relative ${
                idx === 1 ? "lg:pl-16 lg:border-l lg:border-white/20" : ""
              }`}
            >
              <h2 className="text-40 md:text-50 font-bold text-white mb-2 leading-tight">
                {loc.city}
              </h2>
              <p className="text-25 text-white/90 font-normal mb-8">
                {loc.type}
              </p>
              <div className="w-12 h-1 bg-white/30 rounded-full mb-6 lg:hidden"></div>
              <p className="text-20 text-white/80 leading-relaxed max-w-md font-light">
                {loc.address}
              </p>
            </div>
          ))}
        </div>
      </motion.div>
    </section>
  );
}
